
import { Component, Vue } from "vue-property-decorator";
import GeneralFooter from "@/components/general-footer.vue";
import { Getter, Mutation } from "vuex-class";
import { SinglePagePayload } from "@/store/mutations";
import { FormValues } from "@/interfaces/FormValues";
import { AUSPRAEGUNG_ROUTE_NAME } from "@/router";
import { PAGE_NAMES } from "@/constants/form-page-names";
import { CONTENT_FIELD_NAMES } from "@/constants/form-field-names";
import { TYPE_OF_ORDER_VALUES } from "@/constants/shared-input-constants";

@Component({
  components: {
    GeneralFooter,
  },
})
export default class Design extends Vue {
  public form_values: FormValues = {};

  @Getter("allFormValues")
  allFormValues!: Record<string, FormValues>;

  @Mutation("setFormValues")
  setFormValues!: (payload: SinglePagePayload) => void;

  typeOfOrderValues = TYPE_OF_ORDER_VALUES;

  FIELD_NAMES = CONTENT_FIELD_NAMES;

  typeOfOrderRadioOptions = {
    [this.typeOfOrderValues.NEW_ORDER]: "Neuer Spot",
    [this.typeOfOrderValues.ALREADY_EXISTING_ORDER]:
      "Anpassung bestehender Spot",
  };

  mounted() {
    // load from store or set default values
    this.form_values = this.allFormValues[PAGE_NAMES.content] || {
      [this.FIELD_NAMES.typeOfOrder]: this.typeOfOrderValues.NEW_ORDER,
      [this.FIELD_NAMES.jlsAllowedToChangeText]: true,
    };
  }

  get title(): string {
    return (this.form_values[this.FIELD_NAMES.spotTitle] as string) || "";
  }

  get text(): string {
    return (this.form_values[this.FIELD_NAMES.spotText] as string) || "";
  }

  get isNewOrder(): boolean {
    return (
      this.form_values[this.FIELD_NAMES.typeOfOrder] ===
      this.typeOfOrderValues.NEW_ORDER
    );
  }
  get titleFieldLabel(): string {
    return this.isNewOrder ? "Titel *" : "Neuer Titel (falls gewünscht)";
  }
  get titleFieldHelp(): string {
    return `Der Titel wird etwas grösser als der Copytext angezeigt. Wir empfehlen maximal 30 Zeichen zu verwenden (${this.title.length}/30).`;
  }

  get textFieldLabel(): string {
    return this.isNewOrder ? "Text *" : "Neuer Text (falls gewünscht)";
  }
  get textFieldHelp(): string {
    return `Hier können Sie Ihre Text-Botschaft verfassen. Tipp: Denken Sie daran, dass man bei digitalen Contents mit kurzen prägnanten Sätzen am meisten Aufmerksamkeit erzielt. Wir empfehlen maximal 80 Zeichen zu verwenden (${this.text.length}/80).`;
  }

  get callToActionFieldLabel(): string {
    return this.isNewOrder
      ? "Call to Action"
      : "Neuer Call to Action (falls gewünscht)";
  }

  public prev(): void {
    this.$router.go(-1);
  }

  public next(): void {
    this.$router.push({ name: AUSPRAEGUNG_ROUTE_NAME });
  }

  public submit(): void {
    const payload: SinglePagePayload = {
      PAGE_NAME: PAGE_NAMES.content,
      formValues: this.form_values,
    };

    this.setFormValues(payload);

    this.next();
  }
}
